/* Small progressive enhancements for the existing Kalles components. */
(function () {
  'use strict';
  if (window.iprintsyOptimizationLoaded) return;
  window.iprintsyOptimizationLoaded = true;
  var labels = window.iprintsyOptimizationLabels || {};

  function labelIfMissing(element, label) {
    if (!element || !label || (element.getAttribute('aria-label') || '').trim() ||
        (element.getAttribute('aria-labelledby') || '').trim()) return;
    element.setAttribute('aria-label', label);
  }

  function each(root, selector, callback) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function enhanceControls(root) {
    each(root, '.t4s-push-menu-btn', function (el) {
      labelIfMissing(el, labels.openMenu);
    });
    each(root, '.t4s-site-nav__search > a', function (el) {
      labelIfMissing(el, labels.search);
    });
    each(root, '.t4s-site-nav__account > a', function (el) {
      labelIfMissing(el, labels.account);
    });
    each(root, '.t4s-site-nav__cart > a', function (el) {
      labelIfMissing(el, labels.cart);
    });
    each(root, '[data-decrease-qty]', function (el) {
      labelIfMissing(el, labels.decreaseQuantity);
    });
    each(root, '[data-increase-qty]', function (el) {
      labelIfMissing(el, labels.increaseQuantity);
    });
    each(root, 'input[data-quantity-value]', function (el) {
      labelIfMissing(el, labels.quantity);
    });
    each(root, '.t4s-search-form__clear-action', function (el) {
      labelIfMissing(el, labels.clearSearch);
    });
    each(root, '.t4s-search-form__connected-submit', function (el) {
      labelIfMissing(el, labels.search);
    });
    each(root, '.t4s-search-form__input', function (el) {
      labelIfMissing(el, labels.search);
    });
    each(root, '.t4s-layout__switch button[data-col]', function (el) {
      var columns = el.getAttribute('data-col');
      var label = columns === 'list_t4s' ? labels.listView :
        (columns === '1' ? labels.gridViewSingle :
          (labels.gridView || '').replace('__count__', columns));
      labelIfMissing(el, label);
    });
    each(root, '#t4s-filter-hidden [data-drawer-close]', function (el) {
      /* The theme currently labels this as Close search, although it is a filter. */
      if (labels.closeFilters) el.setAttribute('aria-label', labels.closeFilters);
    });
    each(root, '.t4s-product .t4s-pr-item-btn', labelProductAction);
    each(root, '[data-ipr-swatch-group]', watchSwatchGroup);
    each(root, '[data-ipr-price-label]', watchPriceLabel);
  }

  function labelProductAction(element) {
    var existing = (element.getAttribute('aria-label') || '').trim();
    if (existing || (element.getAttribute('aria-labelledby') || '').trim()) return;
    var text = element.querySelector('.t4s-text-pr');
    var action = text && text.textContent.trim();
    var tooltip = (element.getAttribute('title') || element.getAttribute('data-tooltip') || '').trim();
    if (!action && tooltip && !/^(top|right|bottom|left)$/.test(tooltip)) action = tooltip;
    if (!action) {
      if (element.classList.contains('t4s-pr-quickview')) action = labels.quickView;
      else if (element.classList.contains('t4s-pr-addtocart')) action = labels.addToCart;
      else if (element.classList.contains('t4s-pr-wishlist')) action = labels.addToWishlist;
      else if (element.classList.contains('t4s-pr-compare')) action = labels.compare;
    }
    var product = element.closest('.t4s-product');
    var title = product && product.querySelector('.t4s-product-title');
    var productName = title && title.textContent.trim();
    if (action) labelIfMissing(element, productName ? action + ': ' + productName : action);
  }

  var watchedSwatches = new WeakSet();
  function swatchItems(group) {
    return Array.from(group.querySelectorAll('[data-swatch-item][role="radio"]'))
      .filter(function (item) { return item.closest('[data-ipr-swatch-group]') === group; });
  }

  function swatchCanReceiveFocus(item) {
    var style = window.getComputedStyle(item);
    var group = item.closest('[data-ipr-swatch-group]');
    var groupHidden = group && window.getComputedStyle(group).visibility === 'hidden';
    return !item.hidden && !item.hasAttribute('disabled') &&
      item.getAttribute('aria-disabled') !== 'true' &&
      style.display !== 'none' && (style.visibility !== 'hidden' || groupHidden);
  }

  function syncSwatchGroup(group) {
    var items = swatchItems(group);
    var available = items.filter(swatchCanReceiveFocus);
    var selected = available.find(function (item) { return item.classList.contains('is--selected'); });
    var tabStop = selected || available[0];
    items.forEach(function (item) {
      item.setAttribute('aria-checked', item.classList.contains('is--selected') ? 'true' : 'false');
      item.setAttribute('tabindex', item === tabStop ? '0' : '-1');
    });
  }

  function watchSwatchGroup(group) {
    if (watchedSwatches.has(group)) {
      syncSwatchGroup(group);
      return;
    }
    watchedSwatches.add(group);
    var pending = false;
    function refresh() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (group.isConnected) syncSwatchGroup(group);
      });
    }
    syncSwatchGroup(group);
    group.addEventListener('click', refresh);
    group.addEventListener('keydown', function (event) {
      if (!(event.target instanceof Element)) return;
      var item = event.target.closest('[data-swatch-item][role="radio"]');
      if (!item || item.closest('[data-ipr-swatch-group]') !== group) return;
      var items = swatchItems(group).filter(swatchCanReceiveFocus);
      var index = items.indexOf(item);
      if (index < 0) return;
      var next = item;
      var rtl = window.getComputedStyle(group).direction === 'rtl';
      if (event.key === 'Enter' || event.key === ' ') {
        next = item;
      } else if (event.key === 'Home') {
        next = items[0];
      } else if (event.key === 'End') {
        next = items[items.length - 1];
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        var forward = event.key === 'ArrowRight' && rtl ? -1 : 1;
        next = items[(index + forward + items.length) % items.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        var backward = event.key === 'ArrowLeft' && rtl ? 1 : -1;
        next = items[(index + backward + items.length) % items.length];
      } else return;
      event.preventDefault();
      next.focus({ preventScroll: true });
      next.click();
      refresh();
    });
    new MutationObserver(refresh).observe(group, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-disabled']
    });
  }

  var watchedPriceLabels = new WeakSet();
  function zeroLikeUpper(text, currency) {
    var number = text.match(/[0-9](?:[0-9.,\u00a0\u202f ]*[0-9])?/);
    if (!number) return null;
    var fraction = number[0].match(/([.,])([0-9]{1,3})$/);
    var decimals = fraction && fraction[2].length < 3 ? fraction[2].length : 0;
    if (fraction && currency) {
      try {
        var currencyDecimals = new Intl.NumberFormat('en', { style: 'currency', currency: currency })
          .resolvedOptions().maximumFractionDigits;
        if (currencyDecimals === 0) decimals = 0;
        else if (fraction[2].length === currencyDecimals) decimals = currencyDecimals;
      } catch (error) {}
    }
    var zero = decimals ? '0' + fraction[1] + '0'.repeat(decimals) : '0';
    return text.slice(0, number.index) + zero + text.slice(number.index + number[0].length);
  }

  function syncPriceZero(label) {
    var from = label.querySelector('[data-ipr-price-from]');
    var to = label.querySelector('[data-ipr-price-to]');
    if (!from || !to) return;
    var wrapper = label.closest('.t4s-price_slider_wrapper');
    var input = wrapper && wrapper.querySelector('.t4s-min_price');
    var raw = input ? input.value : from.getAttribute('data-base-cents');
    var digits = from.textContent.replace(/[^0-9]/g, '');
    if (raw === null || raw === '' || Number(raw) !== 0 || !digits || /[1-9]/.test(digits)) return;
    var upperMoney = to.querySelector('[data-hdt-currency]') || to;
    var currency = upperMoney.getAttribute('data-hdt-currency');
    if (currency && !/^[A-Z]{3}$/.test(currency)) currency = null;
    var formatted = zeroLikeUpper(to.textContent.trim(), currency);
    if (!formatted) return;
    var lowerMoney = from.querySelector('.money') || from;
    if (lowerMoney.textContent !== formatted) lowerMoney.textContent = formatted;
    if (currency && lowerMoney.classList.contains('money')) {
      if (lowerMoney.getAttribute('data-hdt-currency') !== currency) lowerMoney.setAttribute('data-hdt-currency', currency);
      if (lowerMoney.getAttribute('data-currency-' + currency.toLowerCase()) !== formatted) {
        lowerMoney.setAttribute('data-currency-' + currency.toLowerCase(), formatted);
      }
    }
  }

  function watchPriceLabel(label) {
    if (watchedPriceLabels.has(label)) return;
    watchedPriceLabels.add(label);
    var pending = false;
    function refresh() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (label.isConnected) syncPriceZero(label);
      });
    }
    syncPriceZero(label);
    new MutationObserver(refresh).observe(label, {
      childList: true, characterData: true, subtree: true, attributes: true,
      attributeFilter: ['data-hdt-currency', 'data-base-cents']
    });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element) || !event.target.closest('[data-currency-item]')) return;
    window.requestAnimationFrame(function () {
      document.querySelectorAll('[data-ipr-price-label]').forEach(syncPriceZero);
    });
  });

  function installSearchRecovery() {
    var template = document.getElementById('ipr-search-recovery-template');
    var target = document.querySelector('.t4s-search-page .t4s-coll-empty');
    if (!template || !target || target.querySelector('.ipr-search-recovery')) return;
    target.appendChild(template.content.cloneNode(true));
  }

  var filterOpener = null;
  var filterDrawer = null;
  var observedDrawer = null;

  function isVisible(element) {
    return element && element.isConnected && element.getClientRects().length > 0;
  }

  function filterTrigger(element) {
    if (!element) return null;
    var trigger = element.closest('.t4s-btn-filter, [data-drawer-options]');
    if (!trigger) return null;
    if (trigger.classList.contains('t4s-btn-filter')) return trigger;
    try {
      var options = JSON.parse(trigger.getAttribute('data-drawer-options'));
      return options.id && options.id.indexOf('#t4s-filter-hidden') !== -1 ? trigger : null;
    } catch (error) {
      return null;
    }
  }

  function returnFilterFocus() {
    if (!filterDrawer || !filterDrawer.contains(document.activeElement)) return;
    var opener = filterOpener;
    if (!isVisible(opener)) {
      opener = Array.from(document.querySelectorAll('.t4s-btn-filter, [data-drawer-options]'))
        .find(function (el) { return filterTrigger(el) && isVisible(el); });
    }
    if (opener) opener.focus({ preventScroll: true });
  }

  function watchFilterDrawer() {
    filterDrawer = document.getElementById('t4s-filter-hidden');
    if (filterDrawer) enhanceControls(filterDrawer);
    if (!filterDrawer || observedDrawer === filterDrawer) return;
    observedDrawer = filterDrawer;
    new MutationObserver(function () {
      if (filterDrawer.getAttribute('aria-hidden') === 'true') returnFilterFocus();
    }).observe(filterDrawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* Restore focus before Kalles hides the drawer, avoiding a focused link inside
     aria-hidden. This does not intercept filtering, URLs or the theme's close flow. */
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var opener = filterTrigger(event.target);
    if (opener) {
      filterOpener = opener;
      watchFilterDrawer();
      return;
    }
    if (!filterDrawer) return;
    var close = event.target.closest('[data-drawer-close]');
    var filterLink = event.target.closest('[data-filter-links] a:not([data-not-a-filter])');
    var overlay = event.target.closest('.t4s-close-overlay');
    if ((close && filterDrawer.contains(close)) || filterLink || overlay) returnFilterFocus();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') returnFilterFocus();
  }, true);

  function init() {
    enhanceControls(document);
    installSearchRecovery();
    watchFilterDrawer();
    /* Kalles loads quick views and drawers dynamically. Batch added nodes once
       per animation frame. Only refresh the empty state or drawer when a matching
       component is inserted; review updates do not trigger page-wide queries. */
    var addedRoots = new Set();
    var framePending = false;

    function flushAddedNodes() {
      framePending = false;
      var refreshSearch = false;
      var refreshDrawer = false;
      addedRoots.forEach(function (node) {
        if (!node.isConnected) return;
        enhanceControls(node);
        if (node.matches('.t4s-coll-empty') || node.querySelector('.t4s-coll-empty')) refreshSearch = true;
        if (node.matches('#t4s-filter-hidden') || node.querySelector('#t4s-filter-hidden')) refreshDrawer = true;
      });
      addedRoots.clear();
      if (refreshSearch) installSearchRecovery();
      if (refreshDrawer) watchFilterDrawer();
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) addedRoots.add(node);
        });
      });
      if (addedRoots.size && !framePending) {
        framePending = true;
        window.requestAnimationFrame(flushAddedNodes);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
